module.exports = __webpack_public_path__ + "assets/convert.cda56e10.svg";